<template>
    <v-container fluid>
        <div class="centered-content mt-sm-8 mt-md-12">
            <v-card>
                <v-card-title>Redirection...</v-card-title>
                <v-row>
                    <v-progress-circular :indeterminate="true" color="success" class="ma-12 mx-auto"/>
                </v-row>
            </v-card>
        </div>
    </v-container>
</template>

<script>
	export default {
		name: "LoginSuccess",
		mounted() {
			let location = this.$route.params.redirect;
			if (location) window.location = location;
			else this.$router.push('login');
		}
	}
</script>

<style scoped>
    .centered-content {
        max-width: 600px;
        margin-left: auto;
        margin-right: auto;
    }
</style>
